import axios from 'axios';
import CommonConstants from '../utils/CommonConstants';
const apiUrl = CommonConstants.Actions.api;

const CLEAR_ESTIMATE = "CLEAR_ESTIMATE";
const GET_ESTIMATE_REJECTED = "GET_ESTIMATE_REJECTED";
const GET_ESTIMATE_FULFILLED = "GET_ESTIMATE_FULFILLED";
const GET_ESTIMATE_CALCULATING = "GET_ESTIMATE_CALCULATING";

export function getEstimate(weight,length,width,height,insured_value,special_handling,warehouse_id,destination_country,sc_protect){
	return function(dispatch){
		dispatch({ type: GET_ESTIMATE_CALCULATING })
		axios.post(apiUrl+'shipping-estimate',{
			'item':{
			weight,
			length,
			width,
			height,
			insured_value,
			special_handling,
			warehouse_id,
      destination_country,
			sc_protect,
		},
		}).then((response) => {
			dispatch({
				type: GET_ESTIMATE_FULFILLED,
				payload: response.data
			})

		}).catch((err) =>{
			dispatch({
				type: GET_ESTIMATE_REJECTED,
				payload: err})
			})
		}
}
export function clearEstimate(){
	return function(dispatch){
		dispatch({
			type: CLEAR_ESTIMATE
		})
	}
}



/** WEBPACK FOOTER **
 ** ./src/actions/EstimateAction.js
 **/